var React = require('react');

function SoundStop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z","stroke":"#A1D4AE","key":0}),React.createElement("path",{"d":"M13.5998 6.30078H6.2998V13.6008H13.5998V6.30078Z","fill":"#A1D4AE","key":1})]);
}

SoundStop.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = SoundStop;

SoundStop.default = SoundStop;
